import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"

import CreateV2GBundleProgressStepper from "./components/createV2GBundleProgressStepper"
import BundleManufacturer from "./formPages/bundleManufacturer"
import CoreV2GEVACDetails from "./formPages/coreV2GEVACDetails"
import CoreV2GGenerationDetails from "./formPages/coreV2GGenerationDetails"
import EVACSupportingFiles from "./formPages/evacSupportingFiles"
import ReviewAndSubmitV2GBundle from "./formPages/reviewAndSubmitV2GBundle"
import SelectGenerationPath from "./formPages/selectGenerationPath"
import TypeTestDetailsV2G from "./formPages/typeTestDetailsV2G"
import { CreateV2GBundleContext } from "./providers/baseProviders/createV2GBundleProvider"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"

const CreateV2GBundleForm = (): ReactElement => {
    const { canEditManufacturer, generationMode } = useContext(
        CreateV2GBundleContext
    )

    return (
        <Stack spacing={GRID_SPACING}>
            <AppCard>
                <AppCardContent>
                    <CreateV2GBundleProgressStepper />
                </AppCardContent>
            </AppCard>

            <MultiPageForm context={CreateV2GBundleContext}>
                {canEditManufacturer && <BundleManufacturer />}
                <CoreV2GEVACDetails />
                <SelectGenerationPath />
                {generationMode === "new" && <CoreV2GGenerationDetails />}
                {generationMode === "new" && <TypeTestDetailsV2G />}
                <EVACSupportingFiles />
                <ReviewAndSubmitV2GBundle />
            </MultiPageForm>
        </Stack>
    )
}

export default CreateV2GBundleForm
